import {Component, inject} from '@angular/core';

import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';
import {PdfViewerService} from './pdf-viewer.service';

@Component({
  selector: 'app-pdf-viewer',
  imports: [NzModalModule, NzSkeletonModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.less',
})
export class PdfViewerComponent {
  service = inject(PdfViewerService);

  closePreview(): void {
    this.service.close();
  }
}
